/**
 * Template for generic filters
 * @param {Object} facette - filter[facetteName]
 * @param {Object} wordings - SEARCH_SCRIPTS.WORDING_SEARCH
 * @return {string} - HTML content
 */
export const genericFilterTpl = (facette, wordings) => {
  const facetteName = facette.code.toLowerCase();
  const codeWording = 'facette_' + facetteName + '_label_mobile';

  let htmlFacette = `
    <div class="searchFilters-filterTitle" id="filter_${facetteName}">${wordings[codeWording]}</div>
    <div class="searchFilters-filterBoxContainer searchFilters-filterBoxContainer--${facetteName}">`;

  // build form element
  let count = 0;
  $.each(facette.values, (index, item) => {
    if (facetteName !== 'activities' || (facetteName === 'activities' && count < 21)) {
      const htmlChecked = item.selected ? ' checked="checked"' : '';
      const htmlDisabled = item.enabled || item.checked ? '' : ' u-disabled';
      const inputName = 'facet[' + facette.code + '][]';

      htmlFacette += `
        <div class="searchFilters-filterItem${htmlDisabled}">
          <label for="facette_${facetteName}_${item.key}">
            <div class="form-checkboxContainer">
              <input name="${inputName}" id="facette_${facetteName}_${item.key}" value="${item.key}" class="form-checkbox js-filterInput${htmlDisabled}" type="checkbox" data-facette="${facetteName}"${htmlChecked}>
              <span class="form-checkboxLabel form-label">${item.value}</span>
            </div>
          </label>
        </div>`;
      count++;
    }
  });

  htmlFacette += '</div>';

  if (facetteName === 'activities') {
    htmlFacette += `<div class="searchFilters-opener js-toogleOpener" data-target="activities" data-labelsee="${wordings.seeMoreLabel}" data-labelhide="${wordings.seeLessLabel}">${wordings.seeMoreLabel}</div>`;
  }

  return htmlFacette;
};
